<template>
    <div class="container">
        <div class="topView">
            <span class="topView_span1">可用积分</span>
            <span class="topView_span2">{{integrationSum}}</span>
            <img class="topView_icon" src="../../assets/images/img_integral_detail.png" />
        </div>
        <!-- mapData && Object.keys(mapData).length > 0  v-for="(val,key) in mapData" :key="key"  -->
        <div class="scroll" v-if="dataArray">
            <!-- <div class="listBG" v-if="dataArray"> -->
                <scroll  :allLoaded="allLoaded" :data="dataArray"  @pulldown="loadData" @loadUp="loadup" >
                    <div class="list" v-for="(bitem,index) in dataArray" :key="index" >
                        <div class="listsection">
                            <div class="listsection_line1"></div>
                            <span class="listsection_span">{{bitem.key}}</span>
                        </div>
                        <div class="listItem" v-for="item in bitem.List" :key="item.createTime" >
                            <div class="listItem_left">
                                <span class="listItem_left_span1">{{item.goodsName || item.templateName || item.taskName}}</span>
                                <span class="listItem_left_span2">{{item.createTime}}</span>
                            </div>
                            <div class="listItem_right">
                                <span class="listItem_right_span2" v-if="item.changeval-0 <= 0">{{item.changeval}}</span>
                                <span class="listItem_right_span1" v-else>+{{item.changeval}}</span>
                            </div>
                        </div>
                    </div>
                </scroll>
            <!-- </div> -->

        </div>
        <div class="nodata" v-else>
                <span class="nodata_Span">暂无积分明细</span>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import {getMbUserIntegrationListByUserId} from "../../utils/api";
import Scroll from '../../components/scroll';
export default {
  name: "IntegralDetail",
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  components: {
      Scroll,
  },
  data() {
    return {
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[1,2,3,4,5],
      allLoaded:false,
      integrationSum: 0,
      mapData :'',
      dataArray:[],
      nomessage:false,
     // mbActiveList: [],
      pageNo:1,
    }
  },
  created () {
      this.getMbUserIntegrationListByUserId();

  },
  methods: {
        getMbUserIntegrationListByUserId(){
            var param = {
                "memberCode": this.common.userInfo.memberCode,
                "pageSize": 10,
                "pageNo": this.pageNo,
               // "marketId": '25',
               "marketId":this.common.marketInfo.id,
            }
        getMbUserIntegrationListByUserId( param).then(res => {                //  util.hideLoading()
            if (res.res.code === 10000) {
                console.log(res);
                if (!res.body) { return; }
                let mapData = res.body.mapData || {};
                if (Object.keys(mapData).length === 0) {
                    this.allLoaded = true;
                }
                let length = 0;
                for (var key in mapData) {
                        length += mapData[key].length
                }
                if (length < 10) {
                        this.allLoaded = true;
                }else{
                     this.allLoaded = false;
                }

                if (this.pageNo === 1) {
                    if (Object.keys(mapData).length === 0) {
                    this.mapData = {};
                    this.nomessage = true;
                    } else {
                    this.mapData = mapData;

                    this.nomessage = false;
                    }
                } else {
                    let oldData = this.mapData;
                    let newData = {};
                    for (var i in oldData) {
                    for (var j in mapData) {
                        if (i === j) {
                        newData[i] = oldData[i].concat(mapData[j]);
                        }
                    }
                    }
                    newData = Object.assign({}, oldData, mapData, newData);
                    this.mapData = newData;
                    this.nomessage = false;
                }
                var array =[];
                for (var key in this.mapData) {
                       var  item = {};
                       item.key = key;
                       item.List = this.mapData[key]
                       array.push(item);
                }
                this.dataArray =array;

                this.integrationSum = res.body.integrationSum;
                } else {
                // util.showToast(res.res.msg);
                }
        });

    },
      loadup () {
        if (this.allLoaded) {
            return;
        }
        this.pageNo++;
        this.getMbUserIntegrationListByUserId();
    },
    loadData () {
        this.allLoaded=false;
        this.pageNo = 1;
        this.getMbUserIntegrationListByUserId();
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    height: 100vh;
    position: relative;
    background:#EEEEEE;
    .flex(column);
    .scroll {
        flex: 1;
        height: 500px;
        margin-top: 20px;
        margin-left: 20px;
        // margin-bottom: 80px;
        width:94.7%;
        background:rgba(252,252,252,1);
        box-shadow:0px 4px 8px 0px rgba(0,0,0,0.02);
        border-radius:16px;
    }
}

.topView{
    margin-top: 20px;
    margin-left: 20px;
    width:94.7%;
    height:240px;
    background:rgba(255,255,255,1);
    border-radius:16px;
    position: relative;
    justify-content: center;
    // align-content: center;
    display: flex;
    flex-direction: column;
    .topView_span1{
        margin-top: 52px;
        // display: flex;
       // width:100%;
        text-align: center;
        height:40px;
        font-size:28px;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:40px;
    }
    .topView_span2{
         width:100%;
        text-align: center;
        height:100px;
        font-size:72px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:100px;
    }
    .topView_icon{
        position:absolute;
        right: 40px;
        bottom: 0px;
        width: 116px;
        height: 172px;
        // background-color: red;
    }
}
// .listBG{
    // margin-top: 20px;
    // margin-left: 20px;
    // margin-bottom: 80px;
    // width:94.7%;
    // background:rgba(252,252,252,1);
    // box-shadow:0px 4px 8px 0px rgba(0,0,0,0.02);
    // border-radius:16px;
    .list{
         width:100%;
         display: flex;
        flex-direction: column;
        .listsection{
            width:100%;
            display: flex;
            background-color:#FCFCFC;
            align-items: center;
            height: 88px;
            flex-direction: row;
            .listsection_line1{
                margin-left: 28px;
                margin-right: 14px;
                width:6px;
                height:28px;
                background:rgba(255,126,30,1);
            }
            .listsection_span{
                height:40px;
                font-size:28px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:40px;
            }

        }
        .listItem{
            width:100%;
            display: flex;
            height:120px;
            background:rgba(255,255,255,1);
            flex-direction: row;
            justify-content: space-between;
            .listItem_left{
                margin-left: 28px;
                display: flex;
                flex-direction: column;
                .listItem_left_span1{
                    height:40px;
                    font-size:28px;
                    margin-top: 22px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                    // max-lines: 1;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // -o-text-overflow: ellipsis;
                    // white-space:nowrap;
                    // width:320x;
                    // display:block;

                }
                .listItem_left_span2{
                    height:28px;
                    margin-top: 8px;
                    font-size:24px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:28px;
                    //  .textOver(320px);

                }


            }
            .listItem_right{
                 flex-direction: row;
                 display: flex;
                 margin-right: 28px;
                 align-items: center;
                 .listItem_right_span1{
                     height:32px;
                    font-size:28px;
                    font-weight:400;
                    color:rgba(255,126,30,1);
                    line-height:32px;

                 }
                 .listItem_right_span2{
                       height:32px;
                        font-size:28px;
                        font-weight:400;
                        color:#333333;
                        line-height:32px;

                 }

            }
        }
    }

// }

.nodata{
    background:#EEEEEE;
    width: 100%;
    display: flex;
    margin-top: 100px;
    justify-content: center;
    .nodata_Span{
        text-align: center;
         width: 100%;
         height:44px;
         font-size:32px;
         font-weight:400;
         color:rgba(201,201,201,1);
         line-height:44px;
    }

}

</style>